import React from 'react';
import PropTypes from 'prop-types';
import { compose, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { createBrowserHistory as createHistory } from 'history';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import GoogleTagManager from './GoogleTagManager';
import Core from './Core';

/* REDUCERS */
import contextReducer from './Reducers/context';
import errorCatcherReducer, {
  actions as errorCatcherActions,
} from './Reducers/errorCatcher';

// setting up global vars
window.s = window.s || {};
window.dataLayerGTM = window.dataLayerGTM || [];
// window.flexibility = flexibility;

export const configStore = (rootReducers, rootSagas, reduxTools) => {
  const sagaMiddleware = createSagaMiddleware();
  const history = createHistory();

  let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  if (!reduxTools) {
    composeEnhancers = compose;
  }
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;
  const mystore = createStore(
    rootReducers(history),
    preloadedState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware, routerMiddleware(history)),
    ),
  );
  sagaMiddleware.run(rootSagas);

  return {
    store: mystore,
    history,
  };
};

/**
 * App component.
 * @returns {object} App rendered.
 */
export const App = ({
  projectId,
  urlLibrary,
  modulesLibrary,
  rootReducers,
  rootSagas,
  reduxTools,
  ModalComponent,
  defaultErrorScreen,
  gtmId,
}) => {
  // it must append modules 500 and 404 on modules and urlLibrary
  const newModulesLibrary = modulesLibrary;
  const module404 = newModulesLibrary.find((module) => module.id === '404');
  const module500 = newModulesLibrary.find((module) => module.id === '500');

  if (!module404) {
    newModulesLibrary.push({
      id: '404',
      loader: React.lazy(() => import('./Screens/NotFound')),
    });
  }
  if (!module500) {
    newModulesLibrary.push({
      id: '500',
      loader: React.lazy(() => import('./Screens/Error')),
    });
  }
  
  const { store, history } = configStore(rootReducers, rootSagas, reduxTools);
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <GoogleTagManager gtmId={gtmId} dataLayerName="dataLayerGTM" />
        <Core
          history={history}
          projectId={projectId}
          urlLibrary={urlLibrary}
          modulesLibrary={newModulesLibrary}
          defaultErrorScreen={defaultErrorScreen}
        />
        <ModalComponent projectId={projectId} />
      </ConnectedRouter>
    </Provider>
  );
};

App.propTypes = {
  ModalComponent: PropTypes.func.isRequired,
  defaultErrorScreen: PropTypes.object,
  reduxTools: PropTypes.bool,
  gtmId: PropTypes.string,
};

App.defaultProps = {
  defaultErrorScreen: null,
  reduxTools: false,
  gtmId: 'GTM-KDQ556C',
};

export default App;

/* REDUCERS */
export const APP_CONTROLLER_REDUCERS = {
  context: contextReducer,
  errorCatcher: errorCatcherReducer,
};

export const APP_CONTROLLER_REDUCERS_ACTIONS = {
  errorCatcherActions,
};
